import { apiClient } from '~api/client';
import type { DrillDomainsQueryParams, DrillDomainsResponse } from './drill-domains.types';

/**
 * Drill Domains service for accessing drill domain boundary data
 */
const drillDomainsService = {
  /**
   * Fetch drill domains data
   * @param params - Query parameters (pattern, crs)
   * @returns Promise resolving to drill domains GeoJSON response
   */
  getDrillDomains: async (params: DrillDomainsQueryParams): Promise<DrillDomainsResponse> => {
    const queryParams = { crs: params.crs || 'local' };
    const response = await apiClient.get<DrillDomainsResponse>(`/drill_domains/${params.pattern}`, {
      params: queryParams,
    });
    return response.data;
  },
};

export { drillDomainsService };
